import { Image, useTheme } from "@aws-amplify/ui-react";

export function Header() {
  const { tokens } = useTheme();

  return (
    <Image
      alt="logo"
      src="https://darkstarcdn.s3.us-east-2.amazonaws.com/smh-logo.png"
      padding={tokens.space.medium}
    />
  );
}
